import { mtFetch, type FetchResult } from "./mtFetch";

/** Один API-токен в списке (без plain-значения и без хэша). */
export interface ApiToken {
  readonly token_id: string;
  readonly name: string;
  readonly created_by: string;
  readonly created_at: string | null;
  readonly last_used_at: string | null;
  readonly revoked_at: string | null;
  readonly status: "active" | "revoked";
}

export interface ApiTokenList {
  readonly schema_version: string;
  readonly tokens: readonly ApiToken[];
}

/** Ответ на создание — `token` это plain-значение, показывается один раз. */
export interface ApiTokenCreated {
  readonly schema_version: string;
  readonly token: string;
  readonly token_id: string;
  readonly name: string;
  readonly created_by: string;
  readonly created_at: string | null;
}

export interface ApiTokenRevoked {
  readonly schema_version: string;
  readonly token_id: string;
  readonly revoked: boolean;
}

export function listApiTokens(): Promise<FetchResult<ApiTokenList>> {
  return mtFetch<ApiTokenList>("/admin/api-tokens-list");
}

export function createApiToken(
  name: string,
): Promise<FetchResult<ApiTokenCreated>> {
  return mtFetch<ApiTokenCreated>("/admin/api-tokens-create", {
    method: "POST",
    body: { name },
  });
}

export function revokeApiToken(
  tokenId: string,
): Promise<FetchResult<ApiTokenRevoked>> {
  return mtFetch<ApiTokenRevoked>(
    `/admin/api-tokens-revoke/${encodeURIComponent(tokenId)}`,
    { method: "DELETE" },
  );
}
